<template>
  <div>
    <div class="file-button">
      <el-upload
        class="upload-button"
        :action="uploadUrl"
        :data="data"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        v-if="importButton"
      >
        <el-button
          size="small"
          type="primary"
          plain
          v-loading.fullscreen.lock="fullscreenLoading"
          element-loading-text="导入中..."
          >{{ name }}</el-button
        >
      </el-upload>
      <el-button
        size="small"
        type="primary"
        plain
        @click="handleExport()"
        v-if="exportButton"
        :loading="downloading"
        >{{ exportBtnName }}</el-button
      >
      <el-button
        size="small"
        type="primary"
        plain
        @click="handleExport(true)"
        v-if="importButton && downTemplate"
        >下载模板</el-button
      >
    </div>
  </div>
</template>

<script>
import { fileExport } from '@/service/getData'
import { host, urlPerfix } from '@/config/env'
import store from '@/store/store'
import { clone } from '@/util'
import auth from '@/util/auth'

export default {
  props: {
    obj: {
      type: String,
      default: '',
    },
    importButton: {
      type: Boolean,
      default: true,
    },
    downTemplate: {
      type: Boolean,
      default: true,
    },
    exportButton: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
    },
    name: {
      type: String,
      default: '导入',
    },
    exportBtnName: {
      type: String,
      default: '导出',
    },
  },
  data() {
    return {
      downloading: false,
      auth,
      fullscreenLoading: false,
      data: { obj: this.obj },
      uploadUrl: urlPerfix + '/files/import',
      uploadHeader: { Token: store.state.userInfo.token },
      host: host,
    }
  },
  methods: {
    handleUploadSuccess(res, file) {
      this.fullscreenLoading = false
      if (res.code != 0) {
        this.$alert('导入失败，请刷新页面重试')
      } else {
        this.$emit('importCallback', res)
      }
    },
    handleUploadError() {},
    beforeUpload() {
      this.fullscreenLoading = true
      if (this.filter.customer_id) {
        this.data.customer_id = this.filter.customer_id
      }
    },
    async handleExport(temp = false) {
      let data = {
        obj: this.obj,
        template: temp,
      }
      if (this.obj == 'customer') {
        data = Object.assign(data, this.filter)
        let area = this.filter.area
        if (area.length > 0) {
          data.province = area[0]
        }
        if (area.length > 1) {
          data.city = area[1]
        }
        if (area.length > 2) {
          data.county = area[2]
        }
      } else if (this.obj == 'customer_device') {
        data = {
          obj: this.obj,
          template: temp,
          query: this.filter.query,
          sap_sync: this.filter.sap_sync,
          sold_customer_id: this.filter.sold_customer_id || 0,
          oem_customer_id: this.filter.oem_customer_id || 0,
          install_customer_id: this.filter.install_customer_id || 0,
          customer_id: this.filter.customer_id || 0,
          item_category_id: this.filter.item_category_id,
          status: this.filter.status == null ? -1 : this.filter.status,
          features: this.filter.features || [],
          customer_category: this.filter.customer_category || 0,
          name_plate_no_sn: this.filter.name_plate_no_sn || false,
          platform_user_id: this.filter.platform_user_id || 0,
          telesale_id: this.filter.telesale_id || 0,
          special_mark: this.filter.special_mark || -1,
          important: this.filter.important || 0,
          area_id: this.filter.area_id || 0,
        }

        if (this.filter.date && this.filter.date.length == 2) {
          data.start_time = this.filter.date[0]
          data.end_time = this.filter.date[1]
        }
      } else if (this.obj == 'order') {
        data = clone(this.filter)
        data.obj = this.obj

        data.template = temp

        if (data.date && data.date.length == 2) {
          data.start_date = data.date[0]
          data.end_date = data.date[1]
        }
      } else if (this.obj == 'purchase_order') {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp
        if (data.date && data.date.length == 2) {
          data.start_date = data.date[0]
          data.end_date = data.date[1]
        }
      } else if (this.obj == 'item' || this.obj == 'device') {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp
      } else if (this.obj == 'dealer') {
        data = {
          obj: this.obj,
          template: temp,
          name: this.filter.name,
          rank: this.filter.rank || 0,
          rank_industry: this.filter.rank_industry || 0,
          rank_science: this.filter.rank_science || 0,
          category_id: this.filter.category_id || 0,
          status: this.filter.status || -1,
          user_id: this.filter.user_id || 0,
          industry_sale_id: this.filter.industry_sale_id || 0,
          science_sale_id: this.filter.science_sale_id || 0,
          telesale_id: this.filter.telesale_id || 0,
          customer_count: this.filter.customer_count || 0,
        }
        let area = this.filter.area
        if (area.length > 0) {
          data.province = area[0]
        }
        if (area.length > 1) {
          data.city = area[1]
        }
        if (area.length > 2) {
          data.county = area[2]
        }
      } else if (this.obj == 'used_device') {
        data = {
          obj: this.obj,
          template: temp,
          query: this.filter.query || '',
          status: this.filter.status || 0,
          not_status: this.filter.not_status || 0,
        }
      } else if (this.obj == 'commodity') {
        data = {
          obj: this.obj,
          template: temp,
          name: this.filter.name || '',
          part_number: this.filter.part_number || '',
          category_id: this.filter.category_id || '',
          department_id: this.filter.department_id || '',
          category_ids: this.filter.category_ids.join('&category_ids='),
        }
      } else if (this.obj == 'commodity_order') {
        data = clone(this.filter)
        data.status = 6
        data.obj = this.obj
        data.template = temp

        if (data.date && data.date.length == 2) {
          data.start_date = data.date[0]
          data.end_date = data.date[1]
        }
      } else if (this.obj == 'device_quest') {
        data = clone(this.filter)
        data.status = data.status || 0
        data.obj = this.obj
        data.template = temp
      } else if (this.obj == 'item_category') {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp
      } else if (this.obj == 'customer_device_batch') {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp
      } else if (
        this.obj == 'service_quest' ||
        this.obj == 'service_quest_flow' ||
        this.obj == 'service_quest_all' ||
        this.obj == 'service_quest_flow_all'
      ) {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp
        data.method = 'POST'
      } else if (this.obj == 'service_quest_comment') {
        data = clone(this.filter)
        data.customer_id = data.customer_id || 0
        data.obj = this.obj
        data.template = temp

        if (data.date && data.date.length == 2) {
          data.start_date = data.date[0]
          data.end_date = data.date[1]
        }
      } else if (this.obj == 'customer_issue_device') {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp

        if (data.date && data.date.length == 2) {
          data.start_date = data.date[0]
          data.end_date = data.date[1]
        }
      } else if (this.obj == 'customer_user') {
        data = clone(this.filter)
        data.obj = this.obj
        data.template = temp

        if (data.date && data.date.length == 2) {
          data.start_date = data.date[0]
          data.end_date = data.date[1]
        }
      }

      this.downloading = true

      let res = await fileExport(data)
      if (res.code == 0) {
        this.downloading = false
        window.location.href = res.data
      }
    },
  },
}
</script>

<style scoped>
.upload-button {
  margin-right: 10px;
}

.file-button {
  display: flex;
}
</style>